var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M30.617 39.811a3.5 3.5 0 0 1-1.942-3.135v-12a3.5 3.5 0 1 1 7 0v12a3.5 3.5 0 0 1-5.058 3.135m1.558-1.235a1.9 1.9 0 0 1-1.9-1.9v-12a1.9 1.9 0 0 1 3.8 0v12a1.9 1.9 0 0 1-1.9 1.9M30.617 49.811a3.5 3.5 0 1 0 3.118-6.27 3.5 3.5 0 0 0-3.118 6.27m1.558-1.235a1.9 1.9 0 1 0 0-3.8 1.9 1.9 0 0 0 0 3.8",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M35.485 9.36c-1.53-2.715-5.44-2.715-6.97 0L5.21 50.713c-1.502 2.666.424 5.963 3.485 5.963h46.61c3.06 0 4.987-3.297 3.485-5.964zm21.91 42.138L34.092 10.145c-.918-1.629-3.264-1.629-4.182 0L6.604 51.498c-.901 1.6.255 3.578 2.091 3.578h46.61c1.837 0 2.992-1.978 2.09-3.578",
  clipRule: "evenodd"
})));
export { SvgWarning as ReactComponent };